
import worksData from "../assets/works/works.json";
import { useParams } from "react-router-dom";
import { Suspense, lazy, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import UseImagesLoaded from "../components/UseImagesLoaded";
function WorkDetail(){
    const { slug } = useParams();
    const work = worksData.find(w => w.slug === slug);

    const ArchiveComponent = useMemo(() => {
        return lazy(() => import(`../pages/works/${work.id}.js`));
    }, [work.id]);

    // -- Animation 
    // ArchiveComponent 内の画像が3枚ロードされたら true
    const isReady = UseImagesLoaded(".archive img", 1);

    const variants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.07, duration: 0.7, ease: "easeOut" },
        }),
    };

    // -- 

    return(
        <div className="work-detail">
            <div className="work-detail-conatainer">
                <div className="description-container">
                    <h2>{work.title}</h2>
                    <div className="description-wrapper">
                        {(work.description.en).split('\n').map((text, index) => (
                            <div key={index} className="description-en">
                                {text}
                            </div>
                        ))}
                        <p>-</p>
                        {(work.description.jp).split('\n').map((text, index) => (
                            <div key={index} className="description-jp">
                                {text}
                            </div>
                        ))}
                    </div>
                    {/* <h2>{work.title}</h2> */}
                    {/* <p className="description">{work.description?.[language] || work.description.en}</p> */}
                    <div>
                        <p>Skills / {work.tools}</p>
                        {work.client && work.client.length > 0 && (
                            <p>Client /{" "}
                                {work.client.map((item,index) => (
                                <span key={index}>
                                    {index > 0 && ', '}
                                    {item.url ? (
                                        <a href={item.url} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline 1px' }}>
                                        {item.name}
                                        </a>
                                    ) : (
                                        <span>
                                            {item.name}    
                                        </span>
                                    )}
                                </span>
                                ))}
                            </p>
                        )}
                        {work.agency && work.agency.length > 0 && (
                            <p>Production /{" "}
                                {work.agency.map((item,index) => (
                                <span key={index}>
                                    {index > 0 && ', '}
                                    {item.url ? (
                                        <a href={item.url} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline 1px' }}>
                                        {item.name}
                                        </a>
                                    ) : (
                                        <span>
                                            {item.name}    
                                        </span>
                                    )}
                                </span>
                                ))}
                            </p>
                        )}
                    </div>
                </div>
                <hr className="hr"/>
                {/* <img src={require(`../assets/works/${work.id}/${work.image}`)} alt='main-image' width={1000}/> */}
                {/* <Suspense fallback={<div></div>}>
                    <ArchiveComponent />
                </Suspense> */}
                <Suspense fallback={<div className="loading-blank"></div>}>
                    <AnimatePresence>
                        {isReady && (
                            <motion.div
                                className="archive"
                                initial="hidden"
                                animate="visible"
                                exit="hidden"
                                variants={variants}
                                custom={0} // 最初の要素としてアニメーション
                            >
                                <ArchiveComponent />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </Suspense>
            </div>
        </div>
    );
}

export default WorkDetail;